// extracted by mini-css-extract-plugin
module.exports = {"sm":"576","md":"768","lg":"992","xl":"1200"};